"use client";
import { cssObjectToString } from "../css-object-to-string/css-object-to-string.mjs";
//#region packages/@mantine/core/src/core/InlineStyles/styles-to-string/styles-to-string.ts
function stylesToString({ selector, styles, media, container }) {
	const baseStyles = styles ? cssObjectToString(styles) : "";
	const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item) => `@media${item.query}{${selector}{${cssObjectToString(item.styles)}}}`);
	const containerStyles = !Array.isArray(container) ? [] : container.map((item) => `@container ${item.query}{${selector}{${cssObjectToString(item.styles)}}}`);
	return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}${containerStyles.join("")}`.trim();
}
//#endregion
export { stylesToString };

//# sourceMappingURL=styles-to-string.mjs.map